module.exports = __webpack_public_path__ + "static/media/topArrow.a6168b83.svg";